import { render, staticRenderFns } from "./footer-box.vue?vue&type=template&id=9c435b88&scoped=true&"
import script from "./footer-box.vue?vue&type=script&lang=js&"
export * from "./footer-box.vue?vue&type=script&lang=js&"
import style0 from "./footer-box.vue?vue&type=style&index=0&id=9c435b88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c435b88",
  null
  
)

export default component.exports